import React from "react";
import "./Contact.css";
import { useSEO } from "../components/SEO";
import contactImage from "../assets/contact.webp"; // adjust path if needed

function Contact() {
  useSEO({
    title: "Contact Us | A-Z Blinds – Get a Quote for Window Blinds in Hyderabad",
    description: "Contact A to Z Blinds for free consultation, quotes and expert guidance on roller blinds, zebra blinds, vertical blinds and motorized blinds. WhatsApp, email or visit – Hyderabad.",
    keywords: "contact A to Z Blinds, blinds quote Hyderabad, WhatsApp blinds, blinds consultation Hyderabad, atozblinds contact",
  });

  const phoneNumber = "9440668806";
  const message = encodeURIComponent(
    "Hi! I'm interested in blinds. Please share options and pricing."
  );

  const whatsappLink = `https://wa.me/91${phoneNumber}?text=${message}`;
  const mapsLink =
    "https://www.google.com/maps/place/A+to+Z+Blinds+Hyderabad+Vertical+Venetian+Roller+Zebra+and+Wooden+Window+Blinds+in+Hyderabad/@17.4234665,78.4889886,17z/data=!3m1!4b1!4m6!3m5!1s0x3bcb9919eacca65f:0x3bba4509d196890b!8m2!3d17.4234665!4d78.4889886!16s%2Fg%2F11rfdgzt16?entry=ttu";
  const instagramLink = "https://www.instagram.com/atoz_blinds/";

  return (
    <section className="contactPage">
      <div className="contactCard">
        {/* Left Image */}
        <div
          className="contactImage"
          style={{ backgroundImage: `url(${contactImage})` }}
        />

        {/* Right Content */}
        <div className="contactContent">
          <h1 className="contactTitle">Contact Us</h1>

          <p className="contactSubtitle">
            Transform your spaces with premium blinds crafted for comfort and elegance.
            <br />
            Reach out today for custom designs, pricing, and expert guidance.
          </p>

          <div className="contactDetails">
            {/* WhatsApp row (TEXT label) */}
            <div className="detailRow">
              <span className="detailLabel">WhatsApp</span>
              <a
                className="detailValue link"
                href={whatsappLink}
                target="_blank"
                rel="noreferrer"
              >
                +91 {phoneNumber}
              </a>
            </div>

            {/* Email row */}
            <div className="detailRow">
              <span className="detailLabel">Email</span>
              <a
                className="detailValue link"
                href="mailto:info@atozblinds.in"
              >
               info@atozblinds.in
              </a>
            </div>

            {/* Official icons below */}
            <div className="iconRow">
              {/* Instagram */}
              <a
                href={instagramLink}
                target="_blank"
                rel="noreferrer"
                className="iconBtn"
                title="Instagram"
              >
                <i className="fab fa-instagram"></i>
              </a>

              {/* Maps */}
              <a
                href={mapsLink}
                target="_blank"
                rel="noreferrer"
                className="iconBtn"
                title="Google Maps"
              >
                <i className="fas fa-map-marker-alt"></i>
              </a>

              {/* WhatsApp */}
              <a
                href={whatsappLink}
                target="_blank"
                rel="noreferrer"
                className="iconBtn"
                title="WhatsApp"
              >
                <i className="fab fa-whatsapp"></i>
              </a>
            </div>
          </div>

          <div className="contactNote">
            Available Mon–Sat • Quick responses on WhatsApp
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
